import { builder } from '../../../common/js/config/index';
import { EndScreenType } from '../lib/end-screen/end-screen-types';

// Here this config will be merge with the default video config
export const unmarshaller = {
  skin: builder.holder({
    visibleByDefault: builder.boolean('skins_visible_by_default', {
      optional: true,
      defaultValue: true,
      label: 'Skins visible by default',
      description:
        'Can have the skins visible by default (when ad is not expanded)'
    })
  }),
  endScreen: builder.holder({
    allowListType: builder.arrayString('end_screen_allow_list_type', {
      defaultValue: [
        EndScreenType.DEFAULT,
        EndScreenType.APP_PREVIEW,
        EndScreenType.IMAGE,
        EndScreenType.HTML,
        EndScreenType.IFRAME
      ]
    })
  })
};
